export const FETCH_ERROR = 'Error in Fetch Widgets service';
export const FETCH_ACTION_ERROR = 'Error in Fetch Widgets action';
export const POPULAR_BRAND = 'popular-brands';
export const POPULAR_BRAND2 = 'popular-brands2';
export const EMPTY_STATE_URL =
  'https://images-static.nykaa.com/media/NotFound.svg';
